import { render } from "./totalsubjects.vue?vue&type=template&id=23425cd6"
import script from "./totalsubjects.vue?vue&type=script&lang=js"
export * from "./totalsubjects.vue?vue&type=script&lang=js"

import "./totalsubjects.vue?vue&type=style&index=0&id=23425cd6&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__